import { render, staticRenderFns } from "./GlobalTable.vue?vue&type=template&id=32987ff2&scoped=true&"
import script from "./GlobalTable.vue?vue&type=script&lang=js&"
export * from "./GlobalTable.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTable.vue?vue&type=style&index=0&id=32987ff2&scoped=true&lang=scss&ref=stylesheet%2Fscss&"
import style1 from "./GlobalTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32987ff2",
  null
  
)

export default component.exports